import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    primary: "#79b0e4",
    error: "#ff0000"
  }
});
